<section class="p-3">
    <div class="d-flex justify-content-between">
        <div class="d-block">
            <h4 class="account-section-title">Payment method</h4>
            <p class="section-desc">Click the button to update your payment method.</p>
        </div>
        <button style="height: fit-content;" class="btn light-blue-button  mt-3 mr-3">Update</button>
    </div>
    <div class="section-underline"></div>
    <h4 class="account-section-title mt-3">Billing</h4>
    <p class="section-desc">Change your billing address and manage invoice recipient emails..</p>
    <div class="section-underline"></div>
    <section class="p-4">
        <form>
            <div class="row">
                <div class="d-block col-12 col-md-3">
                    <p class="field-label mb-0">Email address</p>
                    <p class="section-desc">Invoices will be sent to this address.</p>
                </div>
                <div class="d-block col-12 col-md-6">
                    <input name="email" [(ngModel)]="billingUser.email" type="email" class="form-control" />
                </div>
                <div class="section-underline mt-2"></div>
            </div>
            <div class="row mt-3">
                <div class="d-block col-12 col-md-3 mb-2 mb-md-0">
                    <p class="field-label mb-0">Street address</p>
                </div>
                <div class="d-block col-12 col-md-6">
                    <input name="address" [(ngModel)]="billingUser.address" type="text" class="form-control" />
                </div>
                <div class="section-underline mt-3"></div>
            </div>
            <div class="row mt-3">
                <div class="d-block col-12 col-md-3 mb-2 mb-md-0">
                    <p class="field-label mb-0">City</p>
                </div>
                <div class="d-block col-12 col-md-6">
                    <input name="city" [(ngModel)]="billingUser.city" type="text" class="form-control" />
                </div>
                <div class="section-underline mt-3"></div>
            </div>
            <div class="row mt-3">
                <div class="d-block col-12 col-md-3 mb-2 mb-md-0">
                    <p class="field-label mb-0">State</p>
                </div>
                <div class="col-12 col-md-6 row mx-0">
                    <input name="state" [(ngModel)]="billingUser.state" type="text" class="form-control" />
                </div>
                <div class="section-underline mt-3"></div>
            </div>
            <div class="row mt-3">
                <div class="d-block col-12 col-md-3 mb-2 mb-md-0">
                    <p class="field-label mb-0">Country</p>
                </div>
                <div class="col-12 col-md-6">
                    <app-country-picker [alpha2Code]="'US'"></app-country-picker>
                </div>
                <div class="section-underline mt-3"></div>
            </div>
            <div class="d-flex justify-content-end">
                <button class="btn transparent-button mt-3 mr-3">Cancel</button>
                <button (click)="UpdateBillingInfo()" class="btn light-blue-button  mt-3 mr-3">Save</button>
            </div>
        </form>
    </section>
    <h4 class="account-section-title">Invoices</h4>
    <p class="section-desc">Access all your invoices in the table below.</p>
    <div class="section-underline"></div>
    <div class="row mt-3">
        <div class="col-12 col-md-3">
            <p class="field-label mb-1">Billing history</p>
            <p class="section-desc">
                For any questions, please feel free to contact our support team at support@vidtao.com.
            </p>
        </div>
        <div class="col-12 col-md-9">
            <section class="p-0 overflow-hidden table-section mb-5">
                <table>
                    <thead style="border-top: none">
                        <tr>
                            <th class="text-center">Invoice</th>
                            <th>Status</th>
                            <th>Amount</th>
                            <th>Plan</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let invoice of invoices">
                            <td class="text-centered" data-label="Invoice">{{invoice.paymentDate | dateFormat}}</td>
                            <td data-label="Status">
                                <div *ngIf="invoice.isPaid" class="d-flex status-container paid-status">
                                    <i class='bx bx-check' style="font-size: 20px;"></i>
                                    <span style="margin-right: 5px;">Paid</span>
                                </div>
                            </td>
                            <td data-label="Amount">${{invoice.amount}}</td>
                            <td data-label="Plan">{{invoice.planName}}</td>
                            <td data-label="Affiliate">
                                <button class="btn">
                                    <span (click)="PreviewSelectedInvoice(invoice)"
                                        style="font-weight: 600; color: #3538CD;" class="section-desc">View</span>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </section>

        </div>

    </div>
</section>